<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/appprotectt-lite",
		    "name": "AppProtectt Lite"
		  }
		}		]
	}
	</script>

<!-- Breadcrumbs Start -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>CodeProtectt</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}} </h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                    <a class="btn-rectangle btn-transparent btn" data-toggle="modal"
                        data-target="#modalContactForm">Request A Demo</a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none subbanner" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
                <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request
                    A Demo</a>
                <a class="btn-rectangle btn-transparent btn ml-2" href="tel:8850106650">
                    <!-- <i class="fa fa-phone" aria-hidden="true"></i>  -->
                    <img src="assets/images/app-protectt/phone_icon.png" alt="Phone">
                    +91-8850106650
                </a>
            </div>
        </div>
    </div>
</div>

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray pt-4">
    <div class="container d-flex">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="agency-benefits">
                    <div class="content">
                        <p>Android & iOS Code Obfuscation – extended protection against reverse engineering & app
                            tampering.</p>
                        <p>Obfuscate your Mobile App source codes in minutes with an easy-to-deploy CodeProtectt
                            solution for your sensitive Mobile Apps. It obfuscates Android and iOS source code developed
                            in Java, Kotlin, Ionic, SWIFT, Objective C and JavaScript. CodeProtectt is an innovative
                            solution safeguards source code from tampering by hackers & fraudsters. It protects code
                            against common cyber threats such as decompilation and decoding the business logic with
                            predictable keywords.</p>

                        <p>Harden your Mobile App source code with next-generation code obfuscation and protect your
                            apps against emerging cyber threats such as code injection, reverse engineering, and
                            tampering. </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="agency-thumb">
                    <div class="thumb" style="display: flex; align-content: center; justify-content: center;">
                        <img src="assets/images/app-protectt/app-protectt_m.webp"
                            alt="Secure Mobile Application with Cyber Security" class="og_image_url" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Other Features -->
<section class="wrapper-card">
    <div class="container-fostrap">
        <div class="content">
            <div class="container appprotecttlitecard">
                <div class="row mt-20">
                    <div class="col-lg-12">
                        <div class="section-title text-center">
                            <h2 class="mt-0">Why CodeProtectt for Mobile App Obfuscation?</h2>
                        </div>
                        <!-- <p class="mt-20" style="text-align: center;">
                            AppProtectt Lite offers innovative Runtime Application Self Protection (RASP) that is
                            automated,
                            intelligent and self-defending and proven to keep you safe from:
                        </p> -->
                    </div>
                </div>
                <!-- 1st row -->
                <div class="row mt-30">
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">code_off</span></li>
                                </ul>
                                <!-- <h4 class="card_title">
                                    Debugging
                                </h4> -->
                                <p class="mt-3 center-text">
                                    CodeProtectt provides a powerful source code protection to Mobile App source code
                                    that conceals the readable naming conventions<span
                                        class="debugging dots">...</span><span class="more debugging">

                                        used in the source code with randomized algorithm chosen place holders without
                                        impacting the business logic, thus making reverse engineering more difficult to
                                        attackers by tracing and analyzing the keywords. </span>
                                </p>
                                <a (click)="myFunction('debugging')" id="debugging-btn" class="myBtn">Read More
                                    ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">webhook</span></li>
                                </ul>
                                <!-- <h4 class="card_title">
                                    Hooking
                                </h4> -->
                                <p class="mt-3 center-text">
                                    CodeProtectt encrypts constants used in the source code to hide the sensitive
                                    information from static analysis tools. The encrypted strings are <span
                                        class="hooking dots">...</span><span class="more hooking"> only decrypted at run
                                        time when it is used by the protected application. It provides an additional
                                        layer of security by transforming the string literals in the code to prevent any
                                        replay attacks and minimize the sensitive key leakages.</span>
                                </p>
                                <a (click)="myFunction('hooking')" id="hooking-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">mobile_screen_share</span></li>
                                </ul>
                                <!-- <h4 class="card_title">
                                    Spoofing
                                </h4> -->
                                <p class="mt-3 center-text">
                                    CodeProtectt changes the control flow of existing source code, it increases the
                                    obfuscation level of the final protected code and makes it more difficult to
                                    trace<span class="spoofing dots">...</span><span class="more spoofing">
                                    </span>
                                </p>
                                <a (click)="myFunction('spoofing')" id="spoofing-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons"> handyman</span></li>
                                </ul>
                                <h4 class="card_title">
                                    Reverse<br />Engineering
                                </h4>
                                <p class="mt-3 center-text">
                                    Reverse Engineering allows hackers to analyse a compiled app and<span
                                        class="reverse dots">...</span><span class="more reverse">
                                        extract information
                                        about its source code. They can then leverage the source code to
                                        execute an attack, access proprietary information, expose vulnerabilities
                                        or repack and redistribute a malicious version to a targeted victim. Your source
                                        code is
                                        at the core of your business operations and AppProtectt Lite acts as the first
                                        line
                                        of
                                        defence in safeguarding it against threats.</span>
                                </p>
                                <a (click)="myFunction('reverse')" id="reverse-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="offset-lg-4"></div>
                    <div class="col-md-4 col-lg-3 mrgnleftb5">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">camera_front</span></li>
                                </ul>
                                <h4 class="card_title">
                                    Man-in-the-Middle Attacks
                                </h4>
                                <p class="mt-3 center-text">
                                    In today’s privacy-focused world, the safety of user data is vital. With the
                                    increasing flow<span class="mitm dots">...</span><span class="more mitm"> of data
                                        between end-users and your app server, Man-in-the-Middle
                                        Attacks try to gain access to and preview information within a secured
                                        communication channel. AppProtectt Lite safeguards your private communications
                                        and
                                        sensitive information against such malicious attacks.</span>
                                </p>
                                <a (click)="myFunction('mitm')" id="mitm-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Comprehensive In-App Protection -->

<!-- <div class="row mobileapplication newcard mt-30">
    <div class="col-md-12 section-title text-center ">
        <h4>Mobile App Security Platform</h4>
    </div>
</div> -->

<div class="container">

    <!--  image right  -->

    <div class="row align-items-center">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="image-container">
                    <img style="width:65%" src="assets/images/codeprotectt/Code obfucation for android.webp"
                        alt="Secure your Mobile Apps with All in One Mobile App Security " />
                </div>
            </div>
        </div>
        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Deep Code Obfuscation in Android Apps</h3>
                    <p class="text-justify">
                        Provide complete obfuscation for Android apps, including obfuscating Android Native code written
                        in Kotlin and Java, control flows, bindings, Android View Models, Code symbols on the Smali code
                        and Reflections in the Android application's main executable. Also includes obfuscating Android
                        system classes, class names, dynamic classes, methods, obfuscating linkages, strings and more.
                        This Includes obfuscation for non-native code like JavaScript.
                    </p>
                    <!-- <p><a routerLink="/appprotectt" class="btn btn-primary">Read More</a></p> -->
                </div>
            </div>

        </div>
    </div>

    <!--  image left  -->
    <div class="row align-items-center">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="image-container">
                    <img style="width:65%" src="assets/images/codeprotectt/Code obfucation for ios.webp"
                        alt="Mobile Application Security Assessment," />
                </div>

                <!-- <div class="img-container">
                    <div class="content">
                        <a>
                            <div class="content-overlay"></div>
                            <img class="content-image" src="assets/images/home/appbind_home.png" alt="appbind">
                            <div class="content-details fadeIn-bottom">
                                <h3 class="content-title">• Zero Factor Authentication</h3>
                                <h3 class="content-title">• Create unique Digital Identity for individual Mobile
                                    app user</h3>
                                <h3 class="content-title">• Eliminate Identity thefts and frauds like SMS
                                    Spoofing </h3>
                                <h3 class="content-title">• Ensure RBI DPSC Compliances</h3>

                            </div>
                        </a>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Deep Code Obfuscation in iOS Apps</h3>
                    <p class="text-justify">Provide complete obfuscation for iOS apps, including obfuscating iOS
                        binaries, iOS code and control flows, iOS bindings, iOS View Controller, iOS app symbols, and
                        OBj-C selRefs, Swizzling in the iOS application's main executable. Also includes obfuscating
                        plist files, info.plist, obfuscating class names, dynamic classes, methods, obfuscating
                        linkages, strings and more. Includes obfuscation for non-native code like JS and more.
                    </p>
                    <!-- <p><a routerLink="/appbind" class="btn btn-primary">Read More</a></p> -->

                </div>
            </div>
        </div>
    </div>

</div>

<!-- Start Agency Benefits Area -->
<div class="container-fluid">
    <div style="background: #F4F4F4" class="section-service section-pb-60">

        <div class="row mt-20">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>CodeProtectt Key Capabilities</h2>
                </div>
            </div>
        </div>
        <div class="thumb col-md-12 text-center">
            <img width="80%" src="assets/images/codeprotectt/codeprotecttkey_1.webp" class="og_image_url"
                alt="Features of the Mobile App Security">
            <!-- <h6 class="mt-2">Predict, Prompt and Prevent from the cyber attacks in real time</h6> -->
        </div>

    </div>
</div>

<div class="container">
    <div class="row mt-30">
        <div class="col-md-12 section-title">
            <h4 class="text-center">Different Flavours of Code Obfuscation</h4>
        </div>
    </div>
    <div class="row p-2">
        <p style="text-align: justify;">Obfuscation works at multiple levels – it is applied at semantic
            structure/lexical code structure or at the level of data structure/control flow. Obfuscation
            techniques also vary according to the operation they perform on the code. Essentially, the
            programing language used in the Mobile App Source Code is the deciding factor to choose which
            type of obfuscation to be applied on the code at what level. There are quite a few techniques
            used in combinations to obfuscate the source code.</p>
    </div>
    <div class="row">
        <div class="col-sm-6 mt-30">
            <div class="card-f">
                <div class="card_content">
                    <h5 class="card_title">Rename Obfuscation</h5>
                    <p class="card_text">Renaming symbols – variables, class names, function / method names ambiguously
                        so that the original intent of using them is intelligently masked. Methods and variables are
                        renamed using meaningless randomly assorted alpha numerical text. It makes it difficult to
                        decompile and understand the control flow. This obfuscates application code developed in Java
                        and Kotlin in Android platform similarly SWIFT and objective –C used in iOS platform. Renaming
                        the original symbols will make it extremely difficult for the attacker to decode the original
                        intention of the source code blocks.</p>
                </div>
            </div>
        </div>
        <div class="col-sm-6 mt-30">
            <div class="card-f">
                <div class="card_content">
                    <h5 class="card_title">String encryption</h5>
                    <p class="card_text">Encrypting all the readable constant strings such as API Keys, URLs, and
                        verbiages visible on the UI of the Apps is critical to eliminate trace back attack where
                        attackers attempt to search the known keywords and try to replace them. The encrypted code
                        will
                        be decrypted at runtime when the app is executed. While encryption helps protect sensitive
                        values, it is important to choose the amount of encryption to be applied wisely as the cost
                        of
                        decryption may incur performance implications.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row">

        <div class="col-sm-6 mt-30">
            <div class="card-f">
                <div class="card_content">
                    <h5 class="card_title">Control/Code Flow Obfuscation</h5>
                    <p class="card_text">Obfuscating code flow is usually the most lucrative way of confusing the
                        program's intent, and the control is passed from one section of the codebase to another. One of
                        the most common ways of implementing this obfuscation method is to use illogical and unexpected
                        statements, adding dead code that would never be executed. This modification is effective in
                        conditional program orientation in the order of program execution statements.</p>
                </div>
            </div>
        </div>
        <div class="col-sm-6 mt-30">
            <div class="card-f">
                <div class="card_content">
                    <h5 class="card_title">Resource Encryption</h5>
                    <p class="card_text">The resources of the applications are intellectual property of the App, the
                        resource will defend against fake App creation by Extracting logos and images. The encrypted
                        resources will be decrypted at runtime. Since resources are already heavy in size the selection
                        of the right encryption algorithms is crucial in avoiding any latency.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Other Features -->
<div class="section-agency-benefit bg-gray section-pb-60 mt-50">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>How CodeProtectt Obfuscation engine works? </h2>
                </div>
            </div>
        </div>
        <div class="container w-100">
            <div class="row justify-content-center">
                <div>
                    <p>
                        <li>No-Code binary Obfuscation Engine to obfuscate the compiled Android APKs and AABs. </li>
                        <li>Pre-compilation code modification for iOS source code.</li>
                        <li>Prevents Reverse Engineering, Rename business logic.</li>
                        <li>Encrypts the sensitive keys using AES Encryption.</li>
                        <li>Accepts the Dynamic Instruction of method exclusion.</li>
                        <li>Produces Mapping File to track crashes.</li>
                        <li>Provides an additional Auto-Sign capability with optional keystore feed.</li>
                    </p>
                </div>
            </div>
            <div class="thumb col-md-12 text-center mt-50">
                <img width="80%" src="assets/images/codeprotectt/framework.webp" class="og_image_url"
                    alt="Features of the Mobile App Security">
                <!-- <h6 class="mt-2">Predict, Prompt and Prevent from the cyber attacks in real time</h6> -->
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div style="background: #163e6f" class="p-2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()"
                    #closebutton>
                    <span style="color: #fff" aria-hidden="true">&times;</span>
                </button>
                <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
                    Contact Us
                </h4>
                <h6 style="color: #fff">Discuss your cyber security needs</h6>
            </div>
            <div style="display: block" class="modal-header text-center">
                <p class="formparagraph1">Protectt.ai cherish your excellent decision Talk to Protectt.ai
                    to
                    learn more about how we can secure your mobile app and its data, by filling out the form below.
                    For
                    product support, please visit our contact sales page.
                </p>
            </div>
            <div class="modal-body mx-3">
                <form [formGroup]="demoForm" class="contactusform">
                    <div class="row">

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
                            <input type="text" placeholder="Enter Your Name" id="form34"
                                class="form-control validate input" formControlName="name" name="name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email*</label>
                            <input type="email" placeholder="Enter Your Email " formControlName="email"
                                class="form-control input" id="email" name="email"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                                Number*</label>
                            <input type="text" placeholder="Enter Your Phone Number" id="form34"
                                class="form-control validate input" formControlName="contactnumber" name="contactnumber"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                </div>
                                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                    Mobile
                                    Number.
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company*</label>
                            <input type="text" placeholder="Enter Your Company Name" id="form34"
                                class="form-control validate input" formControlName="company_name" name="company_name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right"
                                for="form34">Designation*</label>
                            <input type="text" placeholder="Enter Your Designation" id="form34"
                                class="form-control validate input" formControlName="designation" name="designation"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                Slot
                                1*</label>
                            <input type="datetime-local" id="form34" class="form-control validate input"
                                formControlName="time_slot1" name="time_slot1"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
                            </div>
                        </div>
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                Slot
                                2*</label>
                            <input type="datetime-local" id="form34" class="form-control validate input"
                                formControlName="time_slot2" name="time_slot2"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot2.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.time_slot2.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.time_slot2.errors.required">* This field is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="md-form">
                        <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
                            you?</label>
                        <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
                            class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
                    </div>
                    <div class="modal-footer d-flex justify-content-center">
                        <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close"
                            (click)="onReset()">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
